import { Check } from 'lucide-react';

const STEPS = [
  { key: 'paid', label: '💸 Paid', match: ['paid_pending_match','external_paid_pending_match','host_applications_open','host_assigned_pending_confirmation','confirmed_chat_open','completed','review_requested','closed'] },
  { key: 'matching', label: '🪄 Matching', match: ['paid_pending_match','external_paid_pending_match','host_applications_open'] },
  { key: 'found', label: '👻 Host matched', match: ['host_assigned_pending_confirmation','confirmed_chat_open','completed','review_requested','closed'] },
  { key: 'chat', label: '💬 Chat open', match: ['confirmed_chat_open','completed','review_requested','closed'] },
  { key: 'meetup', label: '🕯️ Meetup', match: ['completed','review_requested','closed'] },
  { key: 'review', label: '✨ Review', match: ['closed'] },
];

export default function QuestTimeline({ status }) {
  const currentIdx = (() => {
    if (status === 'paid_pending_match' || status === 'external_paid_pending_match' || status === 'host_applications_open') return 1;
    if (status === 'host_assigned_pending_confirmation') return 2;
    if (status === 'confirmed_chat_open') return 3;
    if (status === 'completed') return 4;
    if (status === 'review_requested') return 4;
    if (status === 'closed') return 5;
    return 0;
  })();

  return (
    <div className="magical-card p-6">
      <div className="text-xs font-bold uppercase tracking-widest text-[#f97316] font-accent mb-4">🗺️ Booking status</div>
      <ol className="space-y-4">
        {STEPS.map((s, i) => {
          const done = i < currentIdx || (i === 0 && currentIdx >= 0 && status);
          const current = i === currentIdx;
          return (
            <li key={s.key} className="flex items-center gap-3" data-testid={`quest-step-${s.key}`}>
              <div className={`quest-node ${done ? 'done' : ''} ${current ? 'current' : ''}`} />
              <span className={`font-semibold ${done ? 'text-[#f97316]' : current ? 'text-[#f97316]' : 'text-[#a3a3a3]'}`}>{s.label}</span>
              {done && <Check size={14} className="text-[#f97316]" />}
            </li>
          );
        })}
      </ol>
    </div>
  );
}
